import { Component, Input, OnInit } from '@angular/core';
import { ComponentModal } from 'src/app/core/models';
import { ModalService } from 'src/app/core/services';
import { UserDetailModalComponent } from '../user-detail-modal/user-detail-modal.component';
import { EditAdminPermissionModalComponent } from '../edit-admin-permission-modal/edit-admin-permission-modal.component';
import { AdminPermissionI18n } from '../permissions/permissions.component';

interface User { id: number; name: string; email: string; permissions: string[] }

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.sass']
})
export class UsersComponent implements OnInit {

  @Input() users = [];

  public permissionI18n = AdminPermissionI18n;

  constructor(
    private modalService: ModalService
  ) { }

  ngOnInit(): void {
  }

  async openDetail(user: User) {
    const result = await this.modalService.show(new ComponentModal(UserDetailModalComponent, {
      user
    }));
  }

  async openEditPermissions(user: User) {
    const result = await this.modalService.show(new ComponentModal(EditAdminPermissionModalComponent, {
      user
    }));
  }

}
